module.exports = __webpack_public_path__ + "img/sack-dollar.9872179a.svg";